export function canonicalJsonString(value: unknown): string {
	const t = typeof value;

	if (t === "bigint" || t === "function" || t === "symbol") {
		throw new Error("BigInts, functions, and symbols are not supported");
	}

	if (
		value === null ||
		t === "string" ||
		t === "boolean" ||
		t === "number" ||
		t === "undefined"
	) {
		return JSON.stringify(value);
	}

	if (Array.isArray(value)) {
		const elements = value.flatMap((v) => (v === undefined ? [] : [canonicalJsonString(v)]));
		return `[${elements.join(",")}]`;
	}

	if (typeof value === "object") {
		// For each key-value pair, flatten the value and sort by key
		const entries = Object.entries(value as object)
			.flatMap(([k, v]) =>
				v === undefined ? [] : ([[k, canonicalJsonString(v)]] satisfies [[string, string]])
			)
			.sort(([a], [b]) => a.localeCompare(b));

		// Combine into a deterministic string representation
		return `{${entries.map(([k, v]) => `"${k}":${v}`).join(",")}}`;
	}

	return String(value);
}
